/**
 * 一元配置 ANOVA の事後検定: Bonferroni 補正つき全対比較
 * 各ペアについて MS_within を誤差とする t 検定の 2 側 p を算出し、比較数 m = k(k-1)/2 で補正
 */

import type { ANOVAResult } from './anova';
import { twoTailedPValue } from './tTest';

export function computeBonferroniAllPairs(
  result: ANOVAResult
): Array<{ leftIndex: number; rightIndex: number; pValue: number; significant: boolean }> {
  const groups = result.groups;
  const k = groups.length;
  if (k < 2) return [];
  const m = (k * (k - 1)) / 2;
  const df = result.dfWithin;
  const msw = result.msWithin;
  const pairs: Array<{
    leftIndex: number;
    rightIndex: number;
    pValue: number;
    significant: boolean;
  }> = [];

  for (let i = 0; i < k; i += 1) {
    for (let j = i + 1; j < k; j += 1) {
      const se =
        groups[i].n > 0 && groups[j].n > 0
          ? Math.sqrt(msw * (1 / groups[i].n + 1 / groups[j].n))
          : 0;
      const tVal = se > 0 ? (groups[j].mean - groups[i].mean) / se : 0;
      const pRaw = twoTailedPValue(Math.abs(tVal), df);
      const pAdj = Math.min(1, pRaw * m);
      pairs.push({
        leftIndex: i,
        rightIndex: j,
        pValue: pAdj,
        significant: pAdj < 0.05,
      });
    }
  }

  return pairs;
}

export function computeBonferroniSignificancePairs(
  result: ANOVAResult
): Array<{ leftIndex: number; rightIndex: number; pValue: number }> {
  return computeBonferroniAllPairs(result)
    .filter((p) => p.significant)
    .map(({ leftIndex, rightIndex, pValue }) => ({ leftIndex, rightIndex, pValue }));
}
